import { memo } from 'react'

import type { IIconsProps } from './icons.types'

const IconCheckCircleBlue = ({
  width = 56,
  height = 56,
  ...props
}: IIconsProps) => {
  return (
    <svg
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 56 56'
      {...props}
    >
      <path
        d='M28 51.333c12.887 0 23.334-10.447 23.334-23.334C51.334 15.113 40.887 4.666 28 4.666c-12.886 0-23.333 10.447-23.333 23.333 0 12.887 10.447 23.334 23.333 23.334z'
        fill='#00AFFF'
      />
      <path
        d='M39.178 22.752a1.74 1.74 0 000-2.417 1.637 1.637 0 00-2.357 0L25.407 32.04l-6.229-6.388a1.637 1.637 0 00-2.357 0 1.74 1.74 0 000 2.417l7.408 7.597c.312.32.736.5 1.178.5.442 0 .866-.18 1.179-.5l12.592-12.915z'
        fill='#fff'
      />
    </svg>
  )
}

export default memo(IconCheckCircleBlue)
